import React from "react";

// Generic pill for any short status word (ENABLED/DISABLED, PENDING/LAUNCHED...).
// Color is derived from the text itself so new enum values still get a sane look.
const StatusBadge = ({ value }) => {
  if (!value)
    return <span className="status-badge status-badge--neutral">—</span>;

  const tone = /ENABLE|LAUNCH|ACTIVE/i.test(value)
    ? "positive"
    : /DISABLE|FAIL|ERROR/i.test(value)
      ? "negative"
      : "neutral";

  return <span className={`status-badge status-badge--${tone}`}>{value}</span>;
};

export default StatusBadge;
